"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonarchFailedRequestError = exports.MonarchBadResponseError = exports.MonarchBadInputError = void 0;
/**
 * MonarchBadInputError is thrown when there is incorrect input to the Monarch Client's constructor or methods
 */
class MonarchBadInputError extends Error {
    constructor(message) {
        super(message);
        this.name = 'MonarchBadInputError';
    }
}
exports.MonarchBadInputError = MonarchBadInputError;
/**
 * MonarchBadResponseError is thrown when Monarch responds with a response status code other than 200
 */
class MonarchBadResponseError extends Error {
    constructor(message, evaluationType, id, statusCode, responseBody) {
        super(message);
        this.evaluationType = evaluationType;
        this.id = id;
        this.statusCode = statusCode;
        this.responseBody = responseBody;
        this.name = 'MonarchBadResponseError';
    }
}
exports.MonarchBadResponseError = MonarchBadResponseError;
/**
 * MonarchFailedRequestError is thrown when the client does not succeed in getting a response from Monarch
 */
class MonarchFailedRequestError extends Error {
    constructor(message, evaluationType, id, innerErr) {
        super(message);
        this.evaluationType = evaluationType;
        this.id = id;
        this.innerErr = innerErr;
        this.name = 'MonarchFailedRequestError';
    }
}
exports.MonarchFailedRequestError = MonarchFailedRequestError;
